export var YfmTableNode;
(function (YfmTableNode) {
    YfmTableNode["Table"] = "yfm_table";
    YfmTableNode["Body"] = "yfm_tbody";
    YfmTableNode["Row"] = "yfm_tr";
    YfmTableNode["Cell"] = "yfm_td";
})(YfmTableNode || (YfmTableNode = {}));
